import { FC, PropsWithChildren } from "react";
import { IconButton, Tooltip } from "@mui/material";

interface ActionButtonProps {
  label: string;
  bgColor: string;
  bgColorHover: string;
  color: string;
  dataTestId?: string;
}

const ActionButton: FC<PropsWithChildren<ActionButtonProps>> = ({
  label,
  bgColor,
  bgColorHover,
  color,
  children,
  dataTestId,
}) => (
  <Tooltip title={label} placement="top" arrow>
    <IconButton
      aria-label={label}
      sx={{
        backgroundColor: bgColor,
        color,
        ":hover": { backgroundColor: bgColorHover },
      }}
      data-testid={dataTestId}
    >
      {children}
    </IconButton>
  </Tooltip>
);

export default ActionButton;
